import {Constants} from "../../../../constants/constants";

export const DIALOG_SIZE = 448;

export const PRIMARY_TEXT_COLOR = "#161616";
export const SECONDARY_TEXT_COLOR = "#797979";
export const PRIMARY_BUTTON = "#14305A";

export const distanceFromLeftOptimizeDialog = (dialogSize: number = DIALOG_SIZE) => {
  const widthOfManifestDrawer = (window.innerWidth * Constants.MANIFEST_DRAWER_RATIO_WIDTH) / 100;
  return (widthOfManifestDrawer - dialogSize) / 2;
};
